// 公共的api
import request from '@/utils/request'
import { SSO, CONTRACT, STORAGEFILE } from '@jy/constant/url'
// 受托方 接口：
export function getBeileeList(data) {
  return request({
    url: CONTRACT.path + '/BaileeC/getBeileeList',
    method: 'post',
    data
  })
}

// 迁移  所属业务板块的options
export function getPlatideList() {
  return request({
    url: CONTRACT.path + '/businessPlate/list',
    method: 'get',
    params: {}
  })
}

// 迁移 获取级联的地区的接口  根据父级地区码获取子地区集合 父级地区码
export function listByParentCode(parentAreaCode) {
  return request({
    url: CONTRACT.path + '/area/listByParentCode',
    method: 'get',
    params: { parentAreaCode }
  })
}

// 获取人员列表 接口：
export function getEmplList(data) {
  return request({
    url: SSO.path + '/employee/getEmplList',
    method: 'post',
    data
  })
}

// 获取岗位列表 接口：
export function getJobList(data) {
  return request({
    url: SSO.path + '/orgInfo/getOrgAllPosition',
    method: 'post',
    data
  })
}

// 获取组织树 接口：
export function QueryOrganTree(data) {
  return request({
    url: SSO.path + '/org/queryOrganTree',
    method: 'post',
    data
  })
}

// 获取岗位树
export function GetJobTree(data) {
  return request({
    url: SSO.path + '/job/getJobTree',
    method: 'post',
    data
  })
}

// 改版后获取组织结构树2
export function QueryOrganTreev(data) {
  return request({
    url: SSO.path + '/org/query/org/position/tree/v2',
    method: 'post',
    data
  })
}

// 上传文件
export function fileUpload(data) {
  return request({
    url: STORAGEFILE.path + '/fdfs/upload',
    method: 'post',
    data
  })
}

// 上传文件删除
export function DeleteByModify(data) {
  return request({
    url: STORAGEFILE + '/fdfs/deleteByModify',
    method: 'post',
    data
  })
}

// 获取适用审批流节点 接口：
export function GetApprovalRecordInfo(data) {
  return request({
    url: SSO.path + '/approvalRecord/getApprovalRecordInfo',
    method: 'post',
    data
  })
}

// 获取适用审批流节点 接口：
export function GetTargetApprovalRecord(data) {
  return request({
    url: SSO.path + '/approvalRecord/getTargetApprovalRecord',
    method: 'post',
    data
  })
}

// 获取公司下拉框
export function orgSelectd(data) {
  return request({
    url: SSO.path + '/org/getOrgSelectd',
    method: 'post',
    data
  })
}